export default __webpack_public_path__ + "static/media/decorativa4.b964c01d.jpg";